/**
 * Utility function to safely import movie posters
 * It tries .jpg first, then .png.
 */
export const getPosterImage = (movieName) => {
    try {
        const formattedName = movieName.replace(/[^a-zA-Z0-9]/g, "");
        return require(`../assets/Posters/${formattedName}.jpg`);
    } catch (err) {
        try {
            const formattedName = movieName.replace(/[^a-zA-Z0-9]/g, "");
            return require(`../assets/Posters/${formattedName}.png`);
        } catch (e) {
            return null; // Fallback if no image found
        }
    }
};